//Principais
import { Component, inject, OnInit, signal, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, ParamMap, Router, RouterLink } from '@angular/router';
import { NgSelectConfig } from "@ng-select/ng-select";
import { ToastrService } from "ngx-toastr";
import { lastValueFrom } from "rxjs";
//Models
import { PerfilAluno } from "src/app/shared/models/aluno/PerfilAluno";
import { ChamadoDeletar } from "src/app/shared/models/chamados/chamadoDeletar";
import { ChamadosAluno } from "src/app/shared/models/chamados/ChamadosAluno";
import { HistoricoChamado } from "src/app/shared/models/chamados/historico";
import { FuncionalidadesCivico } from "../civico-militar/enums/FuncionalidadesCivico";
//Services
import { FormControl, FormGroup } from '@angular/forms';
import { DialogComponent } from 'components/dialog/dialog.component';
import { NgxSpinnerService } from "ngx-spinner";
import { AuthService } from "src/app/shared/auth/services/auth.service";
import { AtribuicaoLoginSed, UserLoginSed } from "src/app/shared/models/sed/UserLogin";
import { AlunoService } from "src/app/shared/services/alunos.service";
import { ChamadoService } from "src/app/shared/services/chamado.service";
import { ConvivaErrorHandlingService } from 'src/app/shared/services/convivaErrorHandlingService';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { EncaminhamentoService } from "src/app/shared/services/encaminhamento.service";
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';
import { CreditoInicial } from '../civico-militar/enums/CreditoInicial';
import { CardConfig } from '../civico-militar/interfaces/card.interface';
import { FatoAluno } from '../civico-militar/interfaces/fatos.interface';
import { FatosAlunosService } from '../civico-militar/services/fatos-alunos.service';
import { FatosService } from '../civico-militar/services/fatos.service';
import { GroupCardService } from '../civico-militar/services/group-cards.service';
import { podeEditarOuExcluirRegistro } from '../civico-militar/utils/fato-aluno-data.rules';
import { isGestorSuart } from '../civico-militar/utils/gestor-suart';

@Component({
  selector: 'app-perfil-aluno',
  templateUrl: './perfil-aluno.component.html',
  styleUrls: ['./perfil-aluno.component.scss'],
  standalone: true,
  imports: [angularCommonImports, convivaCommonImports, libsCommonImports, DialogComponent,RouterLink],
  providers: [DialogService, GroupCardService, FatosService, ConvivaErrorHandlingService,FatosAlunosService]
})

export class PerfilAlunoComponent implements OnInit {
  dialog = inject(DialogService)
  // groupCardService = inject(GroupCardService)
  fatosService = inject(FatosService)
  fatosAlunosService = inject(FatosAlunosService)
  convivaErrorsHandler = inject(ConvivaErrorHandlingService)
  faixasConfig: CardConfig[] = [];
  FuncionalidadesCivico = FuncionalidadesCivico;


  fatoAlunoSelecioado: number;
  parametro: string;
  showDialog = signal<boolean>(false);
  public userLogado: UserLoginSed | null;
  public atribuicoesLogin: AtribuicaoLoginSed;

  public codigoAluno: number;
  public alunoCivicoMilitar: any = false;
  public radig: any;
  public rauf: any;
  public perfilAluno: PerfilAluno;
  public mostrarResultado = false;
  public formPerfilAluno!: FormGroup;
  public formModal!: FormGroup;
  public formModalChamado!: FormGroup;
  public listaChamados: ChamadosAluno[];
  public showChamados = false;
  public CdStChamado = 0;
  public qtyChamados = 0;
  public descricaoExclusao = '';
  public chamadoARemover = 0;
  public showModalExcluirChamado = false;
  public showModalAdicionarChamado = false;
  public codigoChamadoSelected: number;
  public codigoEnvolvidoSelected: number;
  public   get isDiretor() { return this.userLogado?.NumeroComportamento == "3" && this.userLogado.codigoPerfil == 272 }
  public get gestorSuart() { return isGestorSuart(this.userLogado?.codigoPerfil); }
  public motivoExclusao = '';

  /** Nome para exibição: Nome Social (quando existir), caso contrário nome civil — alinhado às demais telas do sistema. */
  get nomeExibicaoAluno(): string {
    const a = this.perfilAluno?.aluno;
    if (!a) {
      return '';
    }
    const social = a.nomeSocial?.trim();
    return social && social.length > 0 ? social : (a.nomeAluno ?? '');
  }

  /** Iniciais derivadas do nome de exibição (mesma regra de filtros > 3 letras utilizada no detalhe de chamado). */
  get iniciaisExibicaoAluno(): string {
    return this.gerarIniciais(this.nomeExibicaoAluno);
  }

  private gerarIniciais(nome: string): string {
    if (!nome?.trim()) {
      return '';
    }
    return nome
      .split(' ')
      .filter((parte) => parte.length > 3)
      .map((parte) => parte.charAt(0))
      .slice(0, 2)
      .join('')
      .toUpperCase();
  }

  anos: number[] = []
  constructor(
    private config: NgSelectConfig,
    private spinnerService: NgxSpinnerService,
    private route: ActivatedRoute,
    private alunoService: AlunoService,
    private chamadoService: ChamadoService,
    private encaminhamento: EncaminhamentoService,
    private toastr: ToastrService,
    private ConvivaErrors: ConvivaErrorHandlingService,
    private router: Router,
    private authService: AuthService,
  ) {
    this.config.notFoundText = "Não encontrado";
    this.route.paramMap.subscribe(params => {
      this.parametro = params.get('codigoAluno') ?? ''
      this.alunoCivicoMilitar = params.get('alunoCivicoMilitar') ?? false;
    });
    this.config.notFoundText = 'Não encontrado';
    this.userLogado = this.authService.getUser();

    if (this.userLogado != null && !this.userLogado.flPsicologo) {
      this.atribuicoesLogin = this.userLogado?.DadosUsuario[0];
    }
  }

  @ViewChild('modalContent') modalContent!: TemplateRef<any>;
  public showModal = false;
  public submittedModal = false;
  public tituloModal = '';
  public fatosAlunos: FatoAluno[] = [];
  public fatosAlunosFiltrados: FatoAluno[] = [];
  public totalCreditos: number = 0;

  public async ngOnInit() {
    this.getYears();
    await this.loadFaixasCreditos();
    this.formPerfilAluno = new FormGroup({
      anoAtual: new FormControl(new Date().getFullYear()),
    });
    this.formPerfilAluno.get('anoAtual')!.valueChanges.subscribe(ano => {
      this.filtrarFatos(ano);
    });

    this.spinnerService.show();

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.codigoAluno = Number(params.get('codigoAluno'));
      this.alunoCivicoMilitar = params.get('alunoCivicoMilitar');
      this.spinnerService.hide();
    });

    await this.getPerfilAluno(this.codigoAluno);
  }

  public temPermissao(permissao: FuncionalidadesCivico) {
    return this.authService.userLogado()?.funcionalidades.includes(permissao)
  }

  private isAlunoCivicoMilitar(): boolean {
    if (this.alunoCivicoMilitar === true || this.alunoCivicoMilitar === 'true' || this.alunoCivicoMilitar === 1 || this.alunoCivicoMilitar === '1') {
      return true;
    }

    return this.userLogado?.alunoCivicoMilitar === true;
  }

  public async getPerfilAluno(codigoAluno: number) {
    if (!Number.isInteger(codigoAluno) || codigoAluno <= 0) {
      this.toastr.error('Código do aluno inválido.');
      return;
    }

    this.spinnerService.show();
    const isAlunoCivicoMilitar = this.isAlunoCivicoMilitar();
    const codigoEscola = this.userLogado?.codigoEscola
      ?? this.atribuicoesLogin?.CodigoEscola
      ?? 0;
    const codigoDiretoria = this.userLogado?.codigoDiretoria
      ?? this.atribuicoesLogin?.CodigoDiretoria
      ?? 0;

    const response = await lastValueFrom(
      this.alunoService.getDadosAlunoGerais(
        codigoAluno,
        codigoEscola > 0 ? codigoEscola : undefined,
        codigoDiretoria > 0 ? codigoDiretoria : undefined,
        isAlunoCivicoMilitar
      )
    )
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.perfilAluno = response.data;
    this.fatosAlunos = this.perfilAluno.fatos;
    this.fatosAlunosFiltrados = this.fatosAlunos;
    this.totalCreditos = this.perfilAluno.totalCreditos;
    this.spinnerService.hide();
    this.mostrarResultado = true;
  }

  public AbrirModal(codigoChamado: number, codigoEnvolvido: number) {
    this.codigoChamadoSelected = codigoChamado;
    this.codigoEnvolvidoSelected = codigoEnvolvido;
    this.submittedModal = false;
    this.formModal = new FormGroup({
    });
    this.showModal = true;
    this.tituloModal = 'Encaminhamentos';
  }

  public async EncaminhamentoPsicologo() {
    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.codigoChamadoSelected,
      codigoEnvolvido: this.codigoEnvolvidoSelected,
      descricaoHistorico: 'Aluno encaminhado',
      statusChamado: 1,//Encaminhado
      nomeArquivo: "",
      caminhoArquivo: "",
      conteudo: "",
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    };
    this.spinnerService.show();
    const response = await lastValueFrom(this.encaminhamento.setCadastrarEncaminhamento(objetoHistorico))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.toastr.success('Chamado encaminhado com sucesso!');
    this.ngOnInit();
    this.Voltar();
    this.FecharModal();
  }

  public async EncaminhamentoPolicia() {
    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.codigoChamadoSelected,
      codigoEnvolvido: this.codigoEnvolvidoSelected,
      descricaoHistorico: 'Aluno encaminhado a Rede protetiva.',
      statusChamado: 2,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    };
    this.spinnerService.show();
    const response = await lastValueFrom(this.encaminhamento.setCadastrarEncaminhamentoPolicia(objetoHistorico))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    } else {
      this.toastr.success('Aluno Encaminhado a Rede protetiva com Sucesso.');
    }
    this.spinnerService.hide();
    this.ngOnInit();
    this.Voltar();
    this.FecharModal();
  }

  public async EncaminhamentoSaude() {
    const objetoHistorico: HistoricoChamado = {
      codigoChamado: this.codigoChamadoSelected,
      codigoEnvolvido: this.codigoEnvolvidoSelected,
      descricaoHistorico: 'Aluno encaminhado a Saúde.',
      statusChamado: 3,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    };
    this.spinnerService.show();
    const response = await lastValueFrom(this.encaminhamento.setCadastrarEncaminhamentoSaude(objetoHistorico))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.spinnerService.hide();
    this.ngOnInit();
    this.Voltar();
    this.FecharModal();
  }

  public FecharModal() {
    this.showModal = false;
  }

  public async ChamadosAberto(perfilChamado: PerfilAluno, codigoStatusChamado: number) {

    this.spinnerService.show();
    this.CdStChamado = codigoStatusChamado;
    //Obtem chamados do aluno com status 0 = Pendente

    const cdEscolaFiltro = this.userLogado!.codigoEscola! || null;

    const cdEscola = cdEscolaFiltro ?? (this.isDiretor ? this.userLogado!.codigoEscola! : null);

    //const cdEscola = this.isDiretor ? this.userLogado!.codigoEscola! : null;

    const response = await lastValueFrom(this.chamadoService.getChamadosPorAluno(perfilChamado.aluno.codigoAluno, codigoStatusChamado, cdEscola))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.listaChamados = response.data;
    this.qtyChamados = this.listaChamados.length;
    this.showChamados = true;
    this.spinnerService.hide();
  }

  IncluirChamado(ra: string, te: number) {
    this.router.navigate(['/cadastrar-chamados/', ra, te]);
  }

  public async ExluirChamado(codigoChamado: number) {
    this.spinnerService.show();
    const chamadoDeletar: ChamadoDeletar = {
      cdChamado: codigoChamado,
      codigoPerfil: this.atribuicoesLogin.CodigoPerfil,
      nomePerfil: this.atribuicoesLogin.NomePerfil
    }
    const response = await lastValueFrom(this.chamadoService.setDeletarChamado(chamadoDeletar))
      .catch((err) => {
        return this.ConvivaErrors.handleResultError(err);
      });
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    } else {
      this.toastr.success('Chamado removido com sucesso!');
    }
    this.spinnerService.hide();
    this.load();
    this.FecharModalExclusao();
  }

  load() {
    (sessionStorage.refresh == 'true' || !sessionStorage.refresh) && location.reload();
    sessionStorage.refresh = false;
  }

  public OnExcluirChamado(codigoChamdo: number) {
    this.showModalExcluirChamado = true;
    this.descricaoExclusao = `Deseja remover o chamado ?`;
    this.chamadoARemover = codigoChamdo;
  }

  public OnIncluirChamado() {
    this.showModalAdicionarChamado = true;
  }

  public FecharModalExclusao() {
    this.showModalExcluirChamado = false;
    this.descricaoExclusao = "";
    this.chamadoARemover = 0;
  }

  public FecharModalInclusao() {
    this.showModalAdicionarChamado = false;
  }

  public Voltar() {
    this.showChamados = false;
  }

  OnVisualizarChamado(id: number) {
    this.router.navigate(['/detalhe/', id]);
  }

  open() {
    this.dialog.open();
  }


  public async loadFaixasCreditos() {
    this.spinnerService.show();
    const response = await lastValueFrom(this.fatosService.getFaixasCreditos())
      .catch((error) => this.convivaErrorsHandler.handleResultError(error));
    if (!response.isSucess) {
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.faixasConfig = response.data.map((x: any) => {
      return {
        cardType: x.id,
        corHexadecimal: x.corHexadecimal,
        min: x.min,
        max: x.max,
        title: x.descricao,
        count: 0
      }
    });
    this.spinnerService.hide();
  }


  getYears() {
    const anoAtual = new Date().getFullYear();
    for (let ano = 2024; ano <= anoAtual; ano++) {
      this.anos.push(ano);
    }
  }

  podeAlterarFato(fato: FatoAluno): boolean {
    return podeEditarOuExcluirRegistro(fato.dataInclusao);
  }

  filtrarFatos(ano: number) {
    this.fatosAlunosFiltrados = this.fatosAlunos.filter(fato => {
      return new Date(fato.dataFato).getFullYear() === ano;
    });

    this.totalCreditos = this.fatosAlunosFiltrados.reduce((total, fato) => total + fato.pontos, CreditoInicial.Valor);
  }

  closeDialog() {
    this.showDialog.set(false);
  }

  toggleDialog(fatoAlunoId?:number) {
    this.fatoAlunoSelecioado = fatoAlunoId ?? 0;
    this.motivoExclusao = '';
    this.showDialog.set(!this.showDialog());
  }


  async OnExcluirFatoAluno(){
    const fato = this.fatosAlunos.find(x => x.idFatoAluno === this.fatoAlunoSelecioado);
    if (!this.gestorSuart && fato && !this.podeAlterarFato(fato)) {
      this.toastr.error(
        'A exclusão só é permitida no mês civil em que o registro foi criado. O prazo para remover este fato já foi encerrado.'
      );
      this.showDialog.set(false);
      return;
    }

    const motivo = this.motivoExclusao.trim();
    if (this.gestorSuart && !motivo) {
      this.toastr.warning('Informe o motivo da exclusão.');
      return;
    }
    if (this.gestorSuart && motivo.length > 500) {
      this.toastr.warning('O motivo deve ter no máximo 500 caracteres.');
      return;
    }

    this.spinnerService.show();
    const payload = {
      idFatoAluno: this.fatoAlunoSelecioado,
      cdUsuario: this.userLogado?.codigoUsuario,
      nmUsuario: this.userLogado?.nome,
      cdPerfil: this.userLogado?.codigoPerfil,
      nmPerfil: this.userLogado?.nomePerfil,
      motivo: this.gestorSuart ? motivo : null,
    }
    const response = await lastValueFrom(this.fatosAlunosService.setExcluirFatoAluno(payload))
            .catch((error) => this.convivaErrorsHandler.handleResultError(error));
    if(!response.isSucess){
      this.toastr.error(response.message);
      this.spinnerService.hide();
      return;
    }
    this.toastr.success('Fato excluído com sucesso!');
    this.fatoAlunoSelecioado = 0;
    this.motivoExclusao = '';
    this.showDialog.set(false);
    await this.getPerfilAluno(this.codigoAluno);
    this.spinnerService.hide();
  }




}
